import { injectIntl } from "react-intl";
import React, { useState } from "react";
import { SettingsTab } from "src/helpers/Enums";
import SmsPricing from "./SmsPricing";
import PublicPageManagement from "./PublicPageManagement";

const Settings = () => {
  const [activeTab, setActiveTab] = useState(SettingsTab.SMS_PRICING);

  return (
    <div className="Page SettingsPage">
      <div className="SettingsPageHeader">
        <div className="PageHeaderTitle">Settings</div>
        <div className="SettingsTabs">
          <button
            type="button"
            className={
              activeTab === SettingsTab.SMS_PRICING
                ? "OfferDetailsChosenTab"
                : "OfferDetailsTab"
            }
            onClick={() => setActiveTab(SettingsTab.SMS_PRICING)}
          >
            {SettingsTab.SMS_PRICING}
          </button>
          <button
            type="button"
            className={
              activeTab === SettingsTab.PUBLIC_PAGE_MANAGEMENT
                ? "OfferDetailsChosenTab"
                : "OfferDetailsTab"
            }
            onClick={() => setActiveTab(SettingsTab.PUBLIC_PAGE_MANAGEMENT)}
          >
            {SettingsTab.PUBLIC_PAGE_MANAGEMENT}
          </button>
        </div>
      </div>

      <div className="SettingsContent">
        {activeTab === SettingsTab.SMS_PRICING ? (
          <SmsPricing />
        ) : (
          <PublicPageManagement />
        )}
      </div>
    </div>
  );
};

export default injectIntl(Settings);
